import React, { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";


// styles
import {
  DivHistoricoImportacao
} from './styles';

import { Icon, Tag, Tooltip, Typography } from "antd";
import moment from "moment";

import Notificacao from "./Notificacao";
import List from "../../../../components/List";

import { getHistoricoImportacao, getNotificacaoImportacao } from "./actions";

import { connect } from "react-redux";

const HistoricoImportacao = (props) => {
  const params = useParams();
  const dispatch = useDispatch();
  const { data, notificacao, isFetching } = useSelector(
    (state) => state.importacao
  );

  const doGetHistoricoImportacao = useCallback((page, pageSize) => {
    dispatch(getHistoricoImportacao({ page, pageSize }, data));
  },[params.cnpj]);

  useEffect(() => {
    doGetHistoricoImportacao();
  }, [doGetHistoricoImportacao]);

  const renderStatus = (status) => {
    switch (status) {
      case 0:
        return <Tag color="#777777">Iniciado</Tag>;
      case 3:
        return <Tag color="#17a2b8">Em agendamento</Tag>;
      case 4:
        return <Tag color="#007bff">Processando</Tag>;
      case 5:
        return <Tag color="#28a745">Finalizado</Tag>;
      case 7:
        return <Tag color="#17a2b8">Aguardando processamento do organizador</Tag>;
      case 8:
        return <Tag color="#EE4B2B">Falhou</Tag>;
      default:
        return <Tag color="#f8f9fa">-</Tag>;
    }
  };

  return (
    <DivHistoricoImportacao>
      {notificacao && <Notificacao />}

      <List
        height="calc(100vh - 560px)"
        header={<Typography.Text strong>Histórico de Importação</Typography.Text>}
        loading={isFetching}
        dataSource={data?.Resultado}
        pagination={{
          total: data.Paginacao?.Total,
          onChange: doGetHistoricoImportacao,
          onShowSizeChange: doGetHistoricoImportacao,
        }}
        renderItem={(item) => (
          <List.Item>
            <div style={{ width: (item.Status === 7) ? 250 : 150, textAlign: "center" }}>
              {renderStatus(item.Status)}
            </div>

            <List.Item.Meta
              title={item.Nome || "-"}
              description={moment(item.DataEnvio).format("L LT")}
            />

            {item.ExisteNotificacao && (
              <Tooltip title="Ver notificação">
                <Icon
                  type="bell"
                  theme="filled"
                  onClick={() => {
                    return Promise.all([
                      dispatch(getNotificacaoImportacao(item.Id, 2)),
                      dispatch(getNotificacaoImportacao(item.Id, 1))
                    ]);
                  }}
                  style={{ fontSize: 20, color: "#ff4d4f" }}
                />
              </Tooltip>
            )}
          </List.Item>
        )}
      />
    </DivHistoricoImportacao>
  );
};

const mapStateToProps = (state) => ({
  app: state,
});

export default connect(mapStateToProps)(HistoricoImportacao);
